module.exports = __webpack_public_path__ + "assets/globe_white.088e5227.svg";